export function getKeyByValue(object, value) {
	return Object.keys(object).find((key) => object[key] === value);
}

export const delay = (n) => new Promise((r) => setTimeout(r, n * 1000));

export function formatTime(time) {
	if (!time) return ` 0' 00"`;
	else
		return `${Math.floor(time / 60)}' ${
			time % 60 < 10 ? "0" + (time % 60) : time % 60
		}"`;
}

/**
 * Devuelve ISO string o null si no es una fecha válida.
 * Acepta el formato de <input type="datetime-local"> (YYYY-MM-DDTHH:mm).
 */
export function toISOStringSafe(value) {
  if (!value) return null;
  try {
    const iso = new Date(value).toISOString();
    return iso;
  } catch {
    return null;
  }
}

/**
 * Mapea arrays con valores mixtos (string | {value,label} | {_id,name}) a un array de strings/IDs.
 */
export function mapValueArray(arr) {
  if (!Array.isArray(arr)) return [];
  return arr.map((item) => {
    if (item == null) return item;
    if (typeof item === "object") {
      return item.value ?? item._id ?? String(item);
    }
    return item;
  });
}

/**
 * Normaliza el payload del artículo antes de enviarlo al backend:
 * - Convierte fechas a ISO.
 * - Convierte readingTime a Number o lo elimina si está vacío.
 * - Normaliza arrays categories/tags/related.
 * - Garantiza la forma de objetos cover/seo.
 */
export function normalizeArticleBeforeSend(article) {
  const a = { ...article };

  // Arrays
  if (Array.isArray(a.categories)) a.categories = mapValueArray(a.categories);
  if (Array.isArray(a.tags)) a.tags = mapValueArray(a.tags);
  if (Array.isArray(a.related)) a.related = mapValueArray(a.related);

  // Número
  if (a.readingTime === "" || a.readingTime == null) {
    delete a.readingTime;
  } else {
    a.readingTime = Number(a.readingTime);
  }

  // Fechas -> ISO
  ["publishedAt", "pinUntil", "expiresAt"].forEach((k) => {
    if (a[k]) {
      const iso = toISOStringSafe(a[k]);
      if (iso) a[k] = iso;
      else delete a[k];
    }
  });

  // cover/seo shape
  a.cover = a.cover ?? {};
  a.cover.alt = a.cover.alt ?? "";
  a.cover.caption = a.cover.caption ?? "";

  a.seo = a.seo ?? {};
  a.seo.metaTitle = a.seo.metaTitle ?? "";
  a.seo.metaDescription = a.seo.metaDescription ?? "";
  a.seo.ogImage = a.seo.ogImage ?? "";

  return a;
}

/**
 * Heurística para saber si un valor parece un File (sin depender de tipos globales).
 */
export function isFileLike(v) {
  if (!v || typeof v !== "object") return false;
  // Navegadores suelen exponer name/size/type/lastModified
  const hasFileShape =
    ("name" in v && "size" in v) || ("type" in v && "lastModified" in v);
  // Si existe File en el entorno y hacemos instanceof, mejor
  const looksInstance =
    typeof File !== "undefined" && v instanceof File
      ? true
      : false;
  return looksInstance || hasFileShape;
}

/**
 * Extrae posibles ficheros a subir (image/cover) de un segundo argumento flexible:
 * - File -> { imageFile: File, coverFile: null }
 * - { image?: File, cover?: File } -> los que existan
 * - null/undefined -> ambos null
 */
export function extractArticleFiles(filesArg) {
  let imageFile = null;
  let coverFile = null;

  if (isFileLike(filesArg)) {
    imageFile = filesArg;
  } else if (filesArg && typeof filesArg === "object") {
    if (isFileLike(filesArg.image)) imageFile = filesArg.image;
    if (isFileLike(filesArg.cover)) coverFile = filesArg.cover;
  }
  return { imageFile, coverFile };
}